// extracted by mini-css-extract-plugin
export default {"interval_toggle_controls":"IntervalToggleButtons_interval_toggle_controls__1tgow"};